import React, { useEffect, useRef, useState } from 'react';

import { useParams } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { fetchWidgetById, recordWidgetView } from '../api/widgets';

import EmbedAutoHeight from '../components/EmbedAutoHeight';
import WidgetPreview from '../widgets/WidgetPreview';

import { DEFAULT_WIDGET_CONFIG } from '../builder/widgetTypes';



function EmbedBlocked({ title, message }) {

  return (

    <div className="min-h-[200px] flex items-center justify-center p-6 bg-slate-50 border border-slate-200 rounded-lg">

      <div className="text-center max-w-sm">

        <p className="text-sm font-bold text-slate-800">{title}</p>

        <p className="text-xs text-slate-500 mt-2">{message}</p>

      </div>

    </div>

  );

}



/**

 * Public widget page — loaded inside customer iframes.

 */

export default function WidgetRuntimePage() {

  const { widgetId } = useParams();

  const viewRecorded = useRef(false);

  const [access, setAccess] = useState(null);

  const [accessLoading, setAccessLoading] = useState(true);



  const { data, isLoading, isError, error } = useQuery({

    queryKey: ['widget-config', widgetId],

    queryFn: () => fetchWidgetById(widgetId),

    enabled: Boolean(widgetId),

    retry: 1,

    staleTime: 60_000,

  });



  useEffect(() => {

    if (!widgetId || viewRecorded.current) return;

    viewRecorded.current = true;



    const referer = typeof document !== 'undefined' ? document.referrer || '' : '';



    recordWidgetView(widgetId, referer)

      .then(setAccess)

      .catch(() => setAccess({ allowed: true, domainOk: true }))

      .finally(() => setAccessLoading(false));

  }, [widgetId]);



  if (isLoading || accessLoading) {

    return (

      <div className="min-h-screen flex items-center justify-center bg-slate-100 p-6">

        <p className="text-sm text-slate-500">Loading widget…</p>

      </div>

    );

  }



  if (isError || !data) {

    return (

      <div className="min-h-screen flex items-center justify-center bg-slate-100 p-6">

        <p className="text-sm text-slate-600 text-center max-w-xs">

          {error?.status === 404

            ? 'Widget not found. Save it in the builder first.'

            : error?.message || 'Could not load widget.'}

        </p>

      </div>

    );

  }



  if (access && !access.domainOk) {

    return (

      <EmbedBlocked

        title="Embed not authorized"

        message="This widget is not allowed on this website. Add your domain in the builder under Allowed domains."

      />

    );

  }



  const config = { ...DEFAULT_WIDGET_CONFIG, ...data.config };



  return (

    <div className="bg-transparent">
      <EmbedAutoHeight widgetId={widgetId} />
      <WidgetPreview config={config} showBranding={false} />
    </div>

  );

}

